const LISTING_SOURCE = {

  id: "listing_source",
  type: "dropdown",
  props: {
    dropdownProps: {
      label: "Source",
      buttonProps: {
        className: "listing_source",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "Own", value: "Own" },
      { label: "Market", value: "Market" },
      { label: "Transaction", value: "Transaction" },
    ],
  }

}

const COL_LISTING_SOURCE = {

  id: "col_listing_source",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [LISTING_SOURCE]

}

const COL_MODAL_LISTING_SOURCE = {

  id: "col_listing_source",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [LISTING_SOURCE]

}

export { LISTING_SOURCE, COL_LISTING_SOURCE, COL_MODAL_LISTING_SOURCE };
